import moment from "moment";
import d3     from 'd3';

import { DateRangePicker } from '../../react/utils/dateRangePicker/DateRangePicker';

import template from "./pDailyReport.html";

export function pDailyReportDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pDailyReportController,
    controllerAs: 'pDailyReport',
    bindToController: true
  };

  return directive;
}

const COLOR_NVA = "#FF644B";
const COLOR_VA = "#00A990";
const COLOR_INACTIVITY_RED = '#FF644B';
const COLOR_INACTIVITY_ORANGE = '#EAA21C';
const COLOR_INACTIVITY_YELLOW = '#FFFC00';
const COLOR_INACTIVITY = "grey";
const COLOR_PROBLEMS = "#5479BD";
const COLOR_TIME_UNREPORTED = "#FF644B";
const COLOR_TIME_REPORTED = "#00A990";

class pDailyReportController {
  constructor ($scope, Auth, Stats, $translate, $filter, $interval, Notes, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.Auth = Auth;
    this.Stats = Stats;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";
    this.$translate = $translate;
    this.$filter = $filter;
    this.dateStartChoice = sessionStorage.getItem("roedl-tl-date-start") ? sessionStorage.getItem("roedl-tl-date-start") : moment().format("YYYY-MM-DD");
    this.dateEndChoice   = sessionStorage.getItem("roedl-tl-date-end") ? sessionStorage.getItem("roedl-tl-date-end") : moment().format("YYYY-MM-DD");

    this.DateRangePicker = DateRangePicker;
    this.dateRangePickerProps = {
      defaultValue: [new Date(this.dateStartChoice), new Date(this.dateEndChoice)],
      onChange: (values) => this.updateDates(values)
    };

    this.dateToday = moment().format("YYYY-MM-DD");

    this.firstRun = true;

    //TODO: REMOVE SHIT
    this.version = window.frontendVersion;
    // this.version = "3.0.0" || window.frontendVersion;

    //END TODO: REMOVE SHIT

    if (localStorage.getItem('roedl-dark-background')) {
      document.querySelector('body,html').classList.add('darkerBackground');
    }
    this.tab = 'dailyReport';

    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        this.refreshSummary();
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  updateDates(values) {
    this.dateStart = moment(values[0]);
    this.dateEnd = moment(values[1]);

    this.dateStartChoice = this.dateStart.format("YYYY-MM-DD");
    this.dateEndChoice = this.dateEnd.format("YYYY-MM-DD");

    sessionStorage.setItem("roedl-tl-date-start" , this.dateStartChoice);
    sessionStorage.setItem("roedl-tl-date-end" , this.dateEndChoice);
    this.refreshSummary();
  }

  refreshSummary() {
    this.dateStart = moment(this.dateStartChoice);
    this.dateEnd = moment(this.dateEndChoice);
    this.state = "loading";
    var future = null;
    if(this.firstRun && !sessionStorage.getItem("roedl-tl-date-start")) {
        future = this.Stats.getDailyReport();
    } else {
      future = this.Stats.getDailyReport(this.dateStart.format("YYYY-MM-DD"), this.dateEnd.format("YYYY-MM-DD"));
    }
    future.then((success) => {
      if(this.firstRun) {
        this.dateStartChoice = moment(success.data.from).format("YYYY-MM-DD");
        this.dateEndChoice = moment(success.data.to).format("YYYY-MM-DD");
        this.dateStart = moment(this.dateStartChoice);
        this.dateEnd = moment(this.dateEndChoice);
        this.firstRun = false;
      }


      this.team = this.deserializeData(success.data);
      this.setupCharts();
      this.state = "loaded";
      this.error = undefined;
    }, (error) => {
      this.state = "error";
      this.error = error;
      this.team = undefined;
      this.chartsShown = false;
    });

  }

  setColor( name, value ) {
    if(value === 0 ) return COLOR_INACTIVITY;
    else if(name  === "1-5" ) return COLOR_INACTIVITY_YELLOW;
    else if(name === "5-30") return COLOR_INACTIVITY_ORANGE;
    else if(name === "30+") return COLOR_INACTIVITY_RED;
  }

  deserializeData(data) {
    var team = angular.copy(data);
    team.clients.map((x) => {
      x.timeMoment = moment.duration(x.time);
      x.timeAsSeconds = x.timeMoment.asSeconds();

      if (x.additionalInfo)
        x.nameWithAdditionalInfo = `(${x.additionalInfo}) ${x.name}`;
    });

    team.interrupts.map((x)=> x.timeMoment = moment.duration(x.time));
    team.processes.map((x)=> x.timeMoment = moment.duration(x.time));
    team.problems.map((x)=> x.timeMoment = moment.duration(x.time));

    team.topTenClients = team.clients
      .filter((a) => a.name != "Internal")
      .sort((a,b) => b.timeMoment.asMilliseconds() - a.timeMoment.asMilliseconds())
      .slice(0, 10)
      .sort((a,b) => b.timeMoment.asMilliseconds() - a.timeMoment.asMilliseconds());

    team.topTenTasks = team.processes
      .sort((a,b) => b.timeMoment.asMilliseconds() - a.timeMoment.asMilliseconds())
      .slice(0, 10)
      .sort((a,b) => b.timeMoment.asMilliseconds() - a.timeMoment.asMilliseconds());

    window.team = team;

    return team;
  }

  print() {
    window.print();
  }

  printLabels(chartClass, dataOriginal) {
    const svg = d3.select(`article.${chartClass} svg`);
    const barsWrap = svg.select("g").select('g').select('g.nv-barsWrap');
    const barLabels = barsWrap.append("g")
    .attr("class","bar-values")
    .attr("transform","translate(10,-20)")
    .style("font-size","12px");

    const data = dataOriginal.map( x => {
      const va = moment.duration(x.time).asSeconds() * x.vaToNva / 100;
      const nva = moment.duration(x.time).asSeconds() * (100 - x.vaToNva) / 100;
      return {
        name: x.name,
        timeAsSeconds: moment.duration(x.time).asSeconds(),
        va,
        nva
      };
    });

    const yMax = data.reduce( (prev, curr) => Math.max(curr.timeAsSeconds, prev), 0 );
    const xScale =  d3.scale.ordinal()
      .domain(data.map( c => c.name))
      .rangeBands([0,690]);

    const yScale = d3.scale.linear()
      .domain([0, yMax])
      .range([80,0]);

    // VA labels
    barLabels.selectAll()
      .data(data)
      .enter()
      .append('text')
      .text((d) => this.$filter("hms")(moment.duration("PT" + d.va + "S").toJSON()) )
      .attr('x', (s) =>  xScale(s.name) )
      .attr('y', (s) =>  yScale(s.va + s.nva) + 12 )
      .attr('height', '60')
      .attr('width', '67')
      .attr('class','va');

    // NVA labels
    barLabels.selectAll()
    .data(data)
    .enter()
    .append('text')
    .text((d) => this.$filter("hms")(moment.duration("PT" + d.nva + "S").toJSON()) )
    .attr('x', (s) =>  xScale(s.name) )
    .attr('y', (s) => yScale(s.va + s.nva))
    .attr('height', '50')
    .attr('width', '67')
    .attr('class','nva');
  }

  setupCharts() {
    angular.element(document).ready(() => {
      this.chartsShown = false;
      var labelRotation = -30;

      this.generatedAt = moment();
      this.oneDay = this.dateStart.format("YYYY-MM-DD") == this.dateEnd.format("YYYY-MM-DD");

      var hhmmssFilter = this.$filter("hhmmss");
      var $filter = this.$filter;

      this.topTenClientsChart = {
        chart: {
          type: 'multiBarChart',
          stacked: true,
          showLegend: true,
          showControls: true,
          reduceXTicks: false,
          legend: {
            key: function(d) { return d.key; },
            color: function(d) {
              var c = d.values.find((value) => value.color);
              return c.color;
            }
          },
          noData: this.$translate.instant("NOTHING_TO_SHOW"),
          height: "220",
          width: "800",
          rotateLabels: labelRotation,
          tooltip:{
            contentGenerator: function (x) {
              return '<p><strong>' + x.data.label + '</strong>  ' + hhmmssFilter(moment.duration("PT" + x.data.value + "S")) + ' - ' + x.data.key + '</p>';
            }
          },
          margin : {
            top: 60,
            right: 50,
            bottom: 80,
            left: 60
          },
          x: function(d){ return d.label; },
          y: function(d){ return d.value; },
          showValues: true,
          valueFormat: function(d){
            return hhmmssFilter(moment.duration("PT" + d + "S"));
          },
          transitionDuration: 500,
          xAxis: {
            tickFormat: function(d){
              return $filter("truncTxt")(d, true, 20, "...");
            }
          },
          yAxis: {
            tickFormat: function(d){
              return hhmmssFilter(moment.duration("PT" + d + "S"));
            }
          },
          fillOpacity: 1
        },
        data: [
          {
            key: this.$translate.instant("STATS.VA"),
            values:
              this.team.topTenClients.map((x) => {
                return {
                  value: moment.duration(x.time).asSeconds() * x.vaToNva / 100,
                  label: x.nameWithAdditionalInfo || x.name,
                  color: COLOR_VA
                };
              }
            )
          },
          {
            key: this.$translate.instant("STATS.NVA"),
            values:
              this.team.topTenClients.map((x) => {
                return {
                  value: moment.duration(x.time).asSeconds() * (100 - x.vaToNva) / 100,
                  label: x.nameWithAdditionalInfo || x.name,
                  color: COLOR_NVA
                };
              }
            )
          }
        ]
      };

      this.topTenTasksChart = {
        chart: {
          type: 'multiBarChart',
          stacked: true,
          showLegend: true,
          reduceXTicks: false,
          legend: {
            key: function(d) { return d.key; },
            color: function(d) {
              var c = d.values.find((value) => value.color);
              return c.color;
            }
          },
          noData: this.$translate.instant("NOTHING_TO_SHOW"),
          height: "220",
          width: "800",
          rotateLabels: labelRotation,
          tooltip:{
            contentGenerator: function (x) {
              return '<p><strong>' + x.data.label + '</strong>  ' + hhmmssFilter(moment.duration("PT" + x.data.value + "S")) + ' - ' + x.data.key + '</p>';
            }
          },
          margin : {
            top: 60,
            right: 50,
            bottom: 80,
            left: 60
          },
          x: function(d){ return d.label; },
          y: function(d){ return d.value; },
          showValues: true,
          valueFormat: function(d){
            return hhmmssFilter(moment.duration("PT" + d + "S"));
          },
          transitionDuration: 500,
          xAxis: {
            tickFormat: function(d){
              return $filter("truncTxt")(d, true, 20, "...");
            }
          },
          yAxis: {
            tickFormat: function(d){
              return hhmmssFilter(moment.duration("PT" + d + "S"));
            }
          },
          fillOpacity: 1
        },
        data: [
          {
            key: this.$translate.instant("STATS.VA"),
            values:
              this.team.topTenTasks.map((x) => {
                return {
                  value: moment.duration(x.time).asSeconds() * x.vaToNva / 100,
                  label: x.name,
                  color: COLOR_VA
                };
              }
            )
          },
          {
            key: this.$translate.instant("STATS.NVA"),
            values:
              this.team.topTenTasks.map((x) => {
                return {
                  value: moment.duration(x.time).asSeconds() * (100 - x.vaToNva) / 100,
                  label: x.name,
                  color: COLOR_NVA
                };
              }
            )
          }
        ]
      };

      // $filter("truncTxt")(x, true, 20, "...");
      // return hhmmssFilter(moment.duration("PT" + x + "S"));

      this.timeReportChart = {
        chart: {
          type: 'pieChart',
          noData: this.$translate.instant("NOTHING_TO_SHOW"),
          height: "200",
          showLegend: false,
          labelType: "key",
          labelsOutside: true,
          tooltip: {
            valueFormatter: function() {
              return "";
            }
          },
          showValues: true,
          x: function(d){ return d.label; },
          y: function(d){ return d.value; },
          transitionDuration: 500
        },
        data: () => {
          if (this.team.percentageOfReportedTime == 0) {
            return [];
          }
          else {
            return [{
              color: COLOR_TIME_REPORTED,
              value: this.team.percentageOfReportedTime,
              label: (Math.min(100, this.team.percentageOfReportedTime * 100)).toFixed(0) + "% - " + this.$translate.instant("STATS.REPORTED_TIME")
            }, {
              color: COLOR_TIME_UNREPORTED,
              value: Math.max(0, 1 - this.team.percentageOfReportedTime),
              label: Math.max(0, 100 - this.team.percentageOfReportedTime * 100).toFixed(0) + "% - " + this.$translate.instant("STATS.UNREPORTED_TIME")
            }];
          }
        }
      };


      var interruptorsData = this.team.interrupts;
      var interruptorsSum = interruptorsData.map(({timeMoment}) => timeMoment.asSeconds()).reduce((a,b) => a + b, 0) || 1;
      var interruptors = interruptorsData.map((x) => {
        return {
          value: x.timeMoment.asSeconds() / interruptorsSum ,
          label: (x.timeMoment.asSeconds() / interruptorsSum * 100).toFixed(0) + "% - " + x.name,
          timeFormatted: hhmmssFilter(moment.duration(x.timeMoment))
        };
      });

      var interruptorsMain = interruptors.filter((x) => x.value > 0.005);
      var interruptorsOthers = interruptors.filter((x) => x.value <= 0.005);

      var interruptorsChartData = interruptorsMain;
      var othersLength = interruptorsOthers.map(x => x.value).reduce(((a, b) => a + b), 0);
      if(othersLength > 0 ){
        interruptorsChartData = interruptorsChartData.concat([
          {
            value: othersLength,
            label: (othersLength *100).toFixed(0) + "% - " + this.$translate.instant("STATS.OTHER")
          }
        ]);
      }
      this.interruptorsChart = {
        chart: {
          type: 'pieChart',
          noData: this.$translate.instant("NOTHING_TO_SHOW"),
          height: "200",
          labelsOutside: true,
          showValues: true,
          tooltip: {
            valueFormatter: function(x) {
              let valueToDisplay = interruptors.find(i => i.value === x).timeFormatted;
              return valueToDisplay;
            }
          },
          showLegend: true,
          legendPosition: "right",
          legend: {
            margin: {
              right: -10
            },
            updateState: false
          },
          labelType: "percent",
          x: function(d){ return d.label; },
          y: function(d){ return d.value; },
          transitionDuration: 500
        },
        data: interruptorsChartData
      };

      var problemsSorted = this.team.problems.sort((a, b) => b.frequency - a.frequency);

      this.problemsChart = {
        chart: {
          type: 'multiBarHorizontalChart',
          noData: this.$translate.instant("NOTHING_TO_SHOW"),
          height: "170",
          showControls: false,
          showLegend: false,
          groupSpacing: 0.3,
          rightAlignYAxis: true,
          fillOpacity: 1,
          valueFormat: function(v){
            return v.toFixed(0);
          },
          showYAxis: false,
          showXAxis: true,
          showValues: true,
          valuePadding: 5,
          yDomain: [0,5],
          margin : {
            top: 10,
            right: 30,
            bottom: 10,
            left: 120
          },
          x: function(d){ return d.label; },
          y: function(d){ return d.value; },

          transitionDuration: 500
        },
        data: [
          {
            values:
              problemsSorted.map((x) => {
                return {
                  value: x.frequency,
                  label: x.name,
                  color: COLOR_PROBLEMS
                };
              }
            )
          }
        ]
      };

      this.inactivityChart = {
        chart: {
          type: 'multiBarChart',
          noData: this.$translate.instant("NOTHING_TO_SHOW"),
          height: "170",
          valueFormat: function(v){
            return v.toFixed(0);
          },
          margin : {
            top: 10,
            right: 50,
            bottom: 30,
            left: 60
          },
          x: function(d){ return d.label; },
          y: function(d){ return d.value; },
          showValues: true,
          transitionDuration: 500,
          showControls: false,
          showLegend: false,
          fillOpacity: 1,
          reduceXTicks: false
        },
        data: [
          {
            values:
              this.team.inactivityRanges.map((x) => {
                return {
                  value: x.value,
                  label: x.name,
                  color: this.setColor(x.name, x.value)
                };
              }
            )
          }
        ]
      };

      this.chartsShown = true;

      this.$scope.$apply();
      this.printLabels('topTenClients', this.team.topTenClients );
      this.printLabels('topTenProcesses', this.team.topTenTasks);
    });
  }

}
